import comNews from '../../components/com-news.vue';
import comProduct from '../../components/com-product.vue';
import {removeRichTextLabel} from '../../assets/js/tools.js';
export default{
    name:'Home',
    data(){
        return{
            imgs:[
                {
                    path:'home-img1.png',
                    title:'标题1',
                },
                {
                    path:'home-img2.png',
                    title:'标题2',
                },
                {
                    path:'home-img3.png',
                    title:'标题3',
                },
            ],
            topInfo:{},
            topInfo6:[],
            topImportantNotice:{},
            importantNotice6:[],
            topNewsInfo:{},
            newsInfo6:[],
            demoProduct:[],
            demoStration:[],
            productState:false,
           
        }
    },
    components:{
        comNews,
        comProduct,
    },
    created(){
        this.getImportantNotice6();
        this.getNewsInfo();
        this.getDemoStrationTop6();
        this.getDemoPrductTop6();
        // this.getTop7();
    },
    methods:{
        getImportantNotice6(){
            this.get(this.api.importantNoticeTop6).then(res=>{
                this.topImportantNotice=res.data[0];
                this.topImportantNotice.abstract=removeRichTextLabel(this.topImportantNotice.fgnr);
                for(var i=1,j=0; i<res.data.length;i++,j++ ){
                    this.importantNotice6[j]=res.data[i];
                    this.importantNotice6[j].createDate=this.importantNotice6[j].createDate.substring(0,10);
                }
                
            }).catch();
        },
        getNewsInfo(){
            this.get(this.api.getNewsInfoTop).then(res=>{
                this.topNewsInfo=res.data[0];
                this.topNewsInfo.abstract=removeRichTextLabel(this.topNewsInfo.fgnr);
                for(var i=1,j=0; i<res.data.length;i++,j++ ){
                    this.newsInfo6[j]=res.data[i];
                    this.newsInfo6[j].createDate=this.newsInfo6[j].createDate.substring(0,10);
                }
                
            }).catch();
        },
        getDemoStrationTop6(){
            this.get(this.api.getDemoStrationTop6).then(res=>{
                this.demoStration=res.data;
                // for(var i=0; i<res.data.length;i++){
                //     this.demoStration[i]=res.data[i];
                //     this.demoStration[i].createDate=this.demoStration[i].createDate.substring(0,10);
                // }
                
            }).catch();
        },
        getDemoPrductTop6(){
            this.get(this.api.getDemoPrductTop6).then(res=>{
                for(var i=0; i<res.data.length;i++){
                   
                    this.demoProduct[i]=res.data[i];
                    this.demoProduct[i].abstract=removeRichTextLabel(this.demoProduct[i].fgnr);
                    this.demoProduct[i].createDate=this.demoProduct[i].createDate.substring(0,10);
                     if(i ==2)
                        break;
                }
                this.productState=true;
            }).catch();
        },
        // getTop7(){
        //     this.get(this.api.getTop,{topSize:7}).then(res=>{
        //         if(res.data[0].id){
        //             this.getTopDetail(res.data[0].id);
        //         }
        //         for(var i=1,j=0; i<res.data.length;i++,j++ ){
        //             this.topInfo6[j]=res.data[i];
        //             this.topInfo6[j].createDate=this.topInfo6[j].createDate.substring(0,10);
        //         }
                
        //     }).catch();
        // },
        // getTopDetail(id){
        //     this.get(this.api.getTopDetail,{id:id}).then(res=>{
        //         this.topInfo=res.data;
        //         this.topInfo.id=id;
        //     }).catch();
        // },
        getDetail(id,type){
            this.$router.push({ path: '/homeDetail',query: {id: id,type:type}});
            
            
        },
        getList(type){
            this.$router.push({ path: '/homeList',query: {type:type}});
        },
        getDemoList(type){
            this.$router.push({ path: '/demoApplication',query: {type:type}});
        }
    }
}